import cx from "classnames";

import TextButton from "../../../common/components/buttons/TextButton";
import { urls } from "../../../routes";

import styles from "../../styles/AccountCreationLegalDisclaimer.module.less";

export type AccountCreationLegalDisclaimerProps = {
  textAlign?: "start" | "center";
};

const AccountCreationLegalDisclaimer = ({
  textAlign = "start",
}: AccountCreationLegalDisclaimerProps) => {
  return (
    <p className={cx(styles.accountCreationDisclaimer, styles[`align-${textAlign}`])}>
      By creating an account, you agree to be bound by our{" "}
      <TextButton className={styles.link} hasUnderline={true} dest={urls.support.termsOfUse()}>
        Terms of Use
      </TextButton>{" "}
      and{" "}
      <TextButton className={styles.link} hasUnderline={true} dest={urls.support.privacyPolicy()}>
        Privacy Policy
      </TextButton>
      .
    </p>
  );
};

export default AccountCreationLegalDisclaimer;
